/**
 * CheckpointTimelinePage — route entry for the admin Checkpoint Timeline
 * module (ODE-P07-T04). Applies the client-side permission mirror (UX only —
 * the server-side OD-015 `checkpoint.view` guard on every endpoint remains the
 * authority) and renders the module. Test seams are passed through (no real
 * fetch in tests).
 *
 * Traces to: ODE-PRD-REQ-045, ODE-PRD-REQ-077, ODE-PRD-REQ-090.
 */

import { useAuth } from '../../auth/AuthContext.js';
import { StateView } from '../../components/StateView.js';
import { hasPermission } from '../../rbac/catalog.js';
import {
  CheckpointTimelineModule,
  type CheckpointTimelineSeams,
} from './CheckpointTimelineModule.js';

export function CheckpointTimelinePage({
  seams,
}: { readonly seams?: CheckpointTimelineSeams } = {}): JSX.Element {
  const { session } = useAuth();
  const allowed = session !== null && hasPermission(session.staff.roles, 'checkpoint.view');
  if (!allowed) {
    return (
      <StateView
        state={{
          kind: 'blocked',
          message: 'Peran tidak memiliki izin checkpoint.view untuk halaman ini.',
        }}
      />
    );
  }
  return <CheckpointTimelineModule seams={seams ?? {}} />;
}
